import { render, staticRenderFns } from "./ManualMarca.vue?vue&type=template&id=34235064&scoped=true"
import script from "./ManualMarca.vue?vue&type=script&lang=js"
export * from "./ManualMarca.vue?vue&type=script&lang=js"
import style0 from "./ManualMarca.vue?vue&type=style&index=0&id=34235064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34235064",
  null
  
)

export default component.exports